import { LanguageCodeType, storage } from 'noddi-util';
import { Dispatch, SetStateAction } from 'react';

type LoadLocalesProps = {
  setIsLanguageLoaded: Dispatch<SetStateAction<boolean>>;
  defaultLanguage?: LanguageCodeType;
  dynamicActivateLocale: (locale: LanguageCodeType) => Promise<void>;
  supportedLocales: readonly LanguageCodeType[];
};

const localeStorageLocaleKey = 'locale';

export async function initLocales({
  setIsLanguageLoaded,
  defaultLanguage = 'en',
  dynamicActivateLocale,
  supportedLocales
}: LoadLocalesProps) {
  const locale = storage.local.getItem<LanguageCodeType>(localeStorageLocaleKey) || defaultLanguage;

  // set default locale if locale is not supported
  if (!supportedLocales.includes(locale)) {
    storage.local.setItem(localeStorageLocaleKey, defaultLanguage);
    return dynamicActivateLocale(defaultLanguage).then(() => setIsLanguageLoaded(true));
  }

  return dynamicActivateLocale(locale).then(() => setIsLanguageLoaded(true));
}
